import React from "react";

const Footer = () => {
  return (
    <div>
      <div className="Footer">
      <div className="Footer-info-wrapper">
        <h1>Contact</h1>
        <div className="Info-footer">
          <p><a href="https://www.google.com/maps/place/Boulder+City+Lock+And+Key/@35.9743439,-114.8451608,17z/data=!3m1!4b1!4m5!3m4!1s0x80c92ad585831789:0x32847d69817ff149!8m2!3d35.9743396!4d-114.8429721
">📍 916 Nevada Way Suite 4, Boulder City, NV 89005</a></p>
          <p><a href="mailto:bckeyz@yahoo.com">📧  bckeyz@yahoo.com</a></p>
          <p><a href="tel:+1702-241-8869">📞 (702) 241 - 8869</a></p>
        </div>
      </div>
      <div className="Reviews-footer">
        <h1>Leave a Review</h1>
        <div className="Reviews-links">
          <a href="https://www.google.com/search?q=boulder+city+lock+and+key&sxsrf=ALiCzsaA1T-jTn1eR0MIJV1GlBWC2yGzyA%3A1653690001173&ei=kU6RYsiZCtDCuvQPr8u6KA&ved=0ahUKEwiIptqo24D4AhVQoY4IHa-lDgUQ4dUDCA4&uact=5&oq=boulder+city+lock+and+key&gs_lcp=Cgdnd3Mtd2l6EAMyBAgjECcyBAgjECcyBAgjECcyCwguEIAEEMcBEK8BMgYIABAeEBYyAggmMgUIABCGAzIFCAAQhgMyBQgAEIYDMgUIABCGAzoKCAAQRxCwAxDJAzoHCAAQRxCwA0oECEEYAEoECEYYAFCtAlitAmCeBGgBcAF4AIABgQGIAYEBkgEDMC4xmAEAoAEByAEEwAEB&sclient=gws-wiz#lrd=0x80c92ad585831789:0x32847d69817ff149,3,,,">
            <img src="https://www.freepnglogos.com/uploads/google-logo-png/google-logo-png-suite-everything-you-need-know-about-google-newest-0.png" alt="Google Logo"></img>
          </a>
          <a href="https://www.yelp.com/writeareview/biz/FN554f5G3p1SjsZQDrw-HQ?return_url=%2Fbiz%2FFN554f5G3p1SjsZQDrw-HQ&review_origin=biz-details-war-button">
            <img src="https://cdn3.iconfinder.com/data/icons/popular-services-brands/512/yelp-512.png" alt="Yelp Logo"></img>
          </a>
          <a href="https://www.angi.com/write-review/10697572">
            <img src="https://selectkitchenandbath.com/wp-content/uploads/2020/05/angies-list-logo.png" alt=""></img>
          </a>
         
        </div>
      </div>
      <div className="Reviews-footer">
        <h1>Business Hours</h1>
        <div className="Info-footer">
          <p>Monday - Friday &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 9:00am - 5:00pm</p>
          <p>Saturday - Sunday &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Closed</p>
          <p>Emergency Service  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;24/7</p>
        </div>
      </div>
    </div>
    <div className="Copywright">
      <p>© 2022 Averi Passmore</p>
      <p> | </p>
      <p>Boulder City Lock and Key</p>
      <p> | </p>
      <p> All Rights Reserved </p>
    </div>
  </div>
    
  )
}

export default Footer;